import { VERSION_STORAGE_KEY_PREFIX, VERSION_STORAGE_VALID_KEY_PREFIX } from '@/utils/constants'
import useLang from '@/utils/useLang'

/** 获取版本更新信息，lang区分语言 */
const useGetVersionKey = () => {
  const lang = useLang()

  const VERSION_STORAGE_KEY = `${VERSION_STORAGE_KEY_PREFIX}_${lang}`
  const VERSION_STORAGE_VALID_KEY = `${VERSION_STORAGE_VALID_KEY_PREFIX}_${lang}`

  return {
    VERSION_STORAGE_KEY,
    VERSION_STORAGE_VALID_KEY
  }
}

export default useGetVersionKey
